export default "/images/chevron-down.svg?c3e123cf78bc368a192f3e2dee97daba";